import MathHelper from './MathHelper';

export default class DrillHoleHelper {
  static create(id, x, y, type = 1) {
    return {
      id,
      x,
      y,
      type,
    };
  }

  static setPosition(drillHole, position) {
    const { id, type } = drillHole;

    return {
      id,
      x: position.x,
      y: position.y,
      type,
    };
  }

  static delta(drillHole, delta) {
    const { id, x, y, type } = drillHole;

    return {
      id,
      x: x + delta.x,
      y: y + delta.y,
      type,
    };
  }

  static flipHorizontal(drillHole, xAxis) {
    const { id, x, y, type } = drillHole;

    return {
      id,
      x: xAxis + (xAxis - x),
      y,
      type,
    };
  }

  static flipVertical(drillHole, yAxis) {
    const { id, x, y, type } = drillHole;

    return {
      id,
      x,
      y: yAxis + (yAxis - y),
      type,
    };
  }

  static reflect(drillHole, axisStart, axisEnd) {
    const { id, type } = drillHole;
    const { x, y } = MathHelper.reflectPoint(drillHole, axisStart, axisEnd);

    return {
      id,
      x,
      y,
      type,
    };
  }
}
